import { Flag } from 'lucide-react';

import { Sheet, SheetContent, SheetTrigger } from '@/_shared/components/ui/sheet';
import { SidebarMenuButton, SidebarMenuItem } from '@/_shared/components/ui/sidebar';

import { FeatureFlagsPanel } from './FeatureFlagsPanel';

export function FeatureFlagsTrigger(): React.ReactElement | null {
  if (!import.meta.env.DEV) return null;

  return (
    <Sheet>
      <SidebarMenuItem>
        <SheetTrigger asChild>
          <SidebarMenuButton tooltip="Feature flags (dev)">
            <Flag className="size-4" />
            <span>Feature flags</span>
          </SidebarMenuButton>
        </SheetTrigger>
      </SidebarMenuItem>
      <SheetContent side="right" className="flex flex-col gap-0 p-0">
        <FeatureFlagsPanel />
      </SheetContent>
    </Sheet>
  );
}
